import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';
import { DatabaseWakeupService } from './database-wakeup.service';

/**
 * One notice for all requests that wait for the database: a small card at
 * the top of the window that does not block the page. While waiting it shows
 * an indeterminate progress bar; after the time ran out an error with
 * "Try again".
 */
@Component({
  selector: 'app-database-wakeup-notice',
  imports: [MatButtonModule, MatProgressBarModule, TranslateModule],
  template: `@switch (wakeup.state()) {
    @case ('waiting') {
      <div class="db-notice" role="status" aria-live="polite">
        <div class="db-notice-body">
          <i class="db-notice-icon app-icon fa-solid fa-database"></i>
          <div class="db-notice-text">
            <strong>{{ 'common.database.wakingUpTitle' | translate }}</strong>
            <span>{{ 'common.database.wakingUpText' | translate }}</span>
          </div>
        </div>
        <mat-progress-bar
          class="db-notice-progress"
          mode="indeterminate"
        ></mat-progress-bar>
      </div>
    }
    @case ('failed') {
      <div class="db-notice db-notice-failed" role="alert">
        <div class="db-notice-body">
          <i class="db-notice-icon app-icon fa-solid fa-circle-exclamation"></i>
          <div class="db-notice-text">
            <strong>{{ 'common.database.failedTitle' | translate }}</strong>
            <span>{{ 'common.database.failedText' | translate }}</span>
          </div>
          <button
            type="button"
            class="db-notice-close"
            [title]="'common.action.close' | translate"
            (click)="wakeup.dismiss()"
          >
            <i class="app-icon fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="db-notice-actions">
          <button
            type="button"
            matButton="filled"
            class="db-notice-retry"
            (click)="wakeup.retryNow()"
          >
            {{ 'common.action.retry' | translate }}
          </button>
        </div>
      </div>
    }
  }`,
  styleUrls: ['./database-wakeup-notice.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatabaseWakeupNoticeComponent {
  protected wakeup = inject(DatabaseWakeupService);
}
